import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Image, { getMapToRatios, getVariantUrls } from '@fenderdigital/react-image';

class OverlayThumb extends PureComponent {
  render() {
    const {
      backgroundColor,
      aspectRatio,
      variantType,
      label,
      image,
      circle,
      labelColor,
      overlay,
      width,
      height,
    } = this.props;
    const imageStyles = `absolute top-0 left-0 w-100 h-100 z-0 bg-${backgroundColor} w-100 h-100`;
    const labelStyles = `relative f3 z-1 white futura-heavy ${labelColor}`;
    const containerStyles =
      'overlay-thumb pointer flex justify-center items-center tc relative overflow-hidden ba b--black-10';
    const blendMode = overlay ? 'multiply' : 'normal';
    const circleStyle = circle ? 'br-100 bn' : '';
    const ratio = getMapToRatios(aspectRatio);
    let images = getVariantUrls(image, aspectRatio, variantType || 'small');
    if (Array.isArray(image)) images = image;
    return (
      <div
        className={`overlay-thumb ${containerStyles} ${circleStyle} bg-${backgroundColor}`}
        style={{ width, height }}
      >
        <div
          className={imageStyles}
          style={{
            mixBlendMode: `${blendMode}`,
          }}
        >
          {images ? <Image images={images} ratio={ratio} /> : null}
        </div>
        {label ? <span className={labelStyles}>{label}</span> : null}
      </div>
    );
  }
}

OverlayThumb.propTypes = {
  aspectRatio: PropTypes.string,
  backgroundColor: PropTypes.string,
  circle: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  label: PropTypes.string,
  labelColor: PropTypes.string,
  overlay: PropTypes.bool,
  variantType: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

OverlayThumb.defaultProps = {
  aspectRatio: 'square',
  backgroundColor: 'transparent',
  circle: false,
  height: '10rem',
  image: null,
  label: null,
  labelColor: 'white',
  overlay: false,
  width: '10rem',
  variantType: 'smallThumb',
};

export default OverlayThumb;
